import { Regions } from "../data/regions";

// Helper function to check if country is in Europe region (excluding Turkey)
export const isEUCountryExcludingTurkey = (countryCode: string): boolean => {
  const europeRegion = Regions.find((region) => region.name === "Europe");
  if (!europeRegion) return false;
  const isInEurope = europeRegion.countries.some(
    (country) => country.code === countryCode
  );
  return isInEurope && countryCode !== "TR";
};
